// Type is the surface's own (inherited) — this module sets only what every notice shares: the
// margin is each placement class's own (plan §2: "one line of text, lowercase, no punctuation"),
// and the kind's colour, read from the four variables each product root defines.
.notice {
  text-transform: lowercase;
}

.notice[data-kind='info'] {
  color: var(--notice-info);
}

.notice[data-kind='success'] {
  color: var(--notice-success);
}

.notice[data-kind='warning'] {
  color: var(--notice-warning);
}

.notice[data-kind='error'] {
  color: var(--notice-error);
}
